<template>
    <div>
        <Table :no-data-text="$t('common.noData')" :columns="columns" :data="tableSatisfactionListData" style="width: 100.1%;">
            <template slot-scope="{row,index}" slot="detail">
                <Button type="info" size="small" @click="caseDetail(row);" v-hasPermission="['cases:satisfaction:detail']">{{ $t('ticket.list.detail') }}</Button>
            </template>
        </Table>
         <!-- :page-size-opts="[2,4,6,8]" -->
        <Page :current="current" :total="dataTotal" show-sizer :page-size="pageSize" @on-change="changePage" @on-page-size-change="changeSize" :transfer="true"></Page>
    </div>
</template>
<script>
    var tableSatisfactionListVue = {};
    export default {
        name: 'TableSatisfaction',
        data () {
            return {
                current:1,
                dataTotal:0,
                pageSize:10,
                subjectSearchKey:'',
                priorityId:'',
                startTime:'',
                endTime:'',
                satisfaction:'',
                columns: [
                    {
                        title: this.$t('satisfaction.ticketID'),
                        key: 'ticketEntityId'
                    },
                    {
                        title: this.$t('satisfaction.summary'),
                        key: 'subject'
                    },
                    {
                        title: this.$t('satisfaction.initiator'),
                        key: 'createdBy'
                    },
                    {
                        title: this.$t('satisfaction.ticketCategory'),
                        key: 'ticketCategoryName'
                    },
                    {
                        title: this.$t('satisfaction.functionCategory'),
                        key: 'functionTypeName'
                    },
                    {
                        title: this.$t('satisfaction.priority'),
                        key: 'priorityName'
                    },
                    {
                        title: this.$t('satisfaction.status'),
                        key: 'statusName'
                    },
                    {
                        title: this.$t('satisfaction.finishTime'),
                        key: 'endTimeString'
                    },
                    {
                        title: this.$t('satisfaction.satisfaction'),
                        key: 'satisfaction',
                        width:178,
                        render: (h, params) => {
                            let value;
                            return h("Rate", {
                                props: {
                                    disabled:true, 
                                    count: 5,
                                    'allow-half':true,
                                    value:params.row.satisfaction
                                }
                            });
                        }
                    },
                    {
                        title: this.$t('common.operation'),
                        slot: 'detail'
                    }
                ],
                tableSatisfactionListData:[]
            }
        },
        beforeCreate: function() {
            tableSatisfactionListVue = this
        },
        mounted: function(){
            tableSatisfactionListVue.getSatisfactionListData();
        },
        methods:{
            showAll: function(subjectSearchKey,priorityId,startTime,endTime,satisfaction){
                tableSatisfactionListVue.subjectSearchKey = subjectSearchKey;
                tableSatisfactionListVue.priorityId = priorityId;
                tableSatisfactionListVue.startTime = startTime;
                tableSatisfactionListVue.endTime = endTime;
                tableSatisfactionListVue.satisfaction = satisfaction;
                tableSatisfactionListVue.getSatisfactionListData();
            },
            // 分页显示数据
            /****************************************************/
            getSatisfactionListData:function() {
                this.$api.ticket.pageTicket({
                    "flag":1,
                    "subject": tableSatisfactionListVue.subjectSearchKey,
                    "priorityId": tableSatisfactionListVue.priorityId,
                    "startTime": tableSatisfactionListVue.startTime,
                    "endTime": tableSatisfactionListVue.endTime,
                    "satisfaction": tableSatisfactionListVue.satisfaction,
                    "pageNum": this.current,
                    "pageSize": this.pageSize
                })
                .then(res => {
                    this.tableSatisfactionListData = res.data.records;
                    // 当前页
                    this.current = res.data.current;
                    // 总条数
                    this.dataTotal = res.data.total;
                });
            },
            changePage: function(current){
                this.current=current;
                tableSatisfactionListVue.getSatisfactionListData();
            },
            changeSize: function(pageSize){
                this.pageSize=pageSize;
                tableSatisfactionListVue.getSatisfactionListData();
            },
            /**********详情*************/ 
            caseDetail: function(row){
                this.$router.push({path:'/cases/caseDetail/',query: {id: row.id}});
            }
        }
    }
</script>
<style scoped>
    .ivu-page
    {
        margin-top: 10px !important;
        margin-bottom: 30px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/cases/satisfaction/TableSatisfaction.vue